export const INDEX_LOADING = 'index/INDEX_LOADING'
export const INDEX_FAIL = 'index/INDEX_FAIL'
export const INDEX_SUCCESS = 'index/INDEX_SUCCESS'
export const INVITATION_SUCCESS = 'index/INVITATION_SUCCESS'
export const INVITATION_FAIL = 'index/INVITATION_FAIL'
export const INVITATION_SENDING = 'index/INVITATION_SENDING'
export const GET_INDEX_DATA_SUCCESS = 'index/GET_INDEX_DATA_SUCCESS'
export const CAREER_DATA_SUCCESS = 'index/CAREER_DATA_SUCCESS'
export const ACCOUNT_SETTING = 'index/ACCOUNT_SETTING'
export const GAME_HISTORY = 'index/GAME_HISTORY'
